export default __webpack_public_path__ + "static/media/Chantix 2.5395709f.png";